import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Zap, CreditCard } from 'lucide-react';
import { trackEvent } from '../lib/fpixel';
type Plan = 'base' | 'elite';
const CHECKOUT_LINKS: Record<Plan, string> = {
  base: 'https://recursosprofesionales.com.ar/checkouts/cn/hWNDSeF5AR6jlZWsyXWMSUqo/es-ar?_r=AQABxS3Mvz4ABZLlmCqmEVdvmBDQ6Ou4gOaDr4EBkObU-lg',
  elite: 'https://recursosprofesionales.com.ar/checkouts/cn/hWNDSeJtLCYqHEcVxUgy4nn0/es-ar?_r=AQABPZRT9tvZWqXicGcGBCG00UodiXwUXEv0DYLZKTTsCDw'
};
const PLAN_VALUE: Record<Plan, number> = {
  base: 22990,
  elite: 29990
};
export function Pricing() {
  const [selected, setSelected] = useState<Plan>('elite');
  const goToCheckout = () => {
    trackEvent('InitiateCheckout', {
      value: PLAN_VALUE[selected],
      currency: 'ARS',
      content_name: selected === 'elite' ? 'Rescate Académico Élite' : 'Rescate Académico Base'
    });
    window.location.href = CHECKOUT_LINKS[selected];
  };
  return <section id="precios" className="w-full bg-[#F6FAF8] py-14 md:py-20 px-4" data-id="element-273">
      <div className="max-w-2xl mx-auto" data-id="element-274">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-xl border border-slate-100 p-6 md:p-10" data-id="element-275">
          {/* Header */}
          <div className="text-center mb-8" data-id="element-276">
            <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-2" data-id="element-277">
              Elegí tu Pack:
            </h2>
            <p className="text-base md:text-lg text-slate-500 font-medium" data-id="element-278">
              Ambas opciones incluyen los 6 Bonos estratégicos
            </p>
          </div>

          {/* BASE option */}
          <button type="button" onClick={() => setSelected('base')} aria-pressed={selected === 'base'} className={`w-full text-left rounded-2xl border-2 p-5 mb-4 transition-colors ${selected === 'base' ? 'border-[#2F6B57] bg-[#F6FAF8]' : 'border-slate-200 bg-white hover:border-slate-300'}`} data-id="element-279">
            <div className="flex items-center gap-4" data-id="element-280">
              <span className={`flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${selected === 'base' ? 'border-[#2F6B57]' : 'border-slate-300'}`} data-id="element-281">
                {selected === 'base' && <span className="w-3 h-3 rounded-full bg-[#2F6B57]" data-id="element-282" />}
              </span>
              <div className="flex-1" data-id="element-283">
                <h3 className="font-bold text-slate-900 text-lg leading-tight" data-id="element-284">
                  📘 RESCATE ACADÉMICO BASE
                </h3>
                <p className="text-slate-500 text-sm mt-1" data-id="element-285">
                  12 Tomos + 6 Bonos
                </p>
              </div>
              <div className="text-right" data-id="element-286">
                <p className="text-slate-400 line-through text-sm" data-id="element-287">$72.000</p>
                <p className="text-2xl font-extrabold text-slate-900" data-id="element-288">
                  $22.990
                </p>
              </div>
            </div>
          </button>

          {/* ÉLITE option */}
          <button type="button" onClick={() => setSelected('elite')} aria-pressed={selected === 'elite'} className={`w-full text-left rounded-2xl border-2 p-5 mb-6 transition-colors ${selected === 'elite' ? 'border-[#C97B5A] bg-[#FBF3EE]' : 'border-slate-200 bg-white hover:border-slate-300'}`} data-id="element-289">
            <div className="flex items-start gap-4" data-id="element-290">
              <span className={`flex-shrink-0 mt-1 w-6 h-6 rounded-full border-2 flex items-center justify-center ${selected === 'elite' ? 'border-[#C97B5A]' : 'border-slate-300'}`} data-id="element-291">
                {selected === 'elite' && <span className="w-3 h-3 rounded-full bg-[#C97B5A]" data-id="element-292" />}
              </span>
              <div className="flex-1" data-id="element-293">
                <h3 className="font-bold text-slate-900 text-lg leading-tight mb-2" data-id="element-294">
                  🏆 RESCATE ACADÉMICO ÉLITE
                </h3>
                <div className="flex flex-wrap gap-2 mb-2" data-id="element-295">
                  <span className="bg-[#CDA24A] text-white text-[11px] font-bold px-3 py-1 rounded-full" data-id="element-296">
                    ⭐ MÁS ELEGIDO
                  </span>
                  <span className="bg-[#F3D9CC] text-[#B5612F] text-[11px] font-bold px-3 py-1 rounded-full" data-id="element-297">
                    AHORRÁS $98.010
                  </span>
                </div>
                <p className="text-slate-500 text-sm" data-id="element-298">
                  12 Tomos + 6 Bonos + 2 EBOOKS ÉLITE
                </p>
              </div>
              <div className="text-right" data-id="element-299">
                <p className="text-slate-400 line-through text-sm" data-id="element-300">$128.000</p>
                <p className="text-2xl font-extrabold text-[#C97B5A]" data-id="element-301">
                  $29.990
                </p>
              </div>
            </div>
          </button>

          {/* CTA */}
          <motion.button type="button" onClick={goToCheckout} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className={`w-full text-white font-bold text-base md:text-xl py-4 md:py-5 rounded-2xl shadow-lg transition-colors ${selected === 'elite' ? 'bg-[#C97B5A] hover:bg-[#B86A49] shadow-[#C97B5A]/30' : 'bg-[#2F6B57] hover:bg-[#255645] shadow-[#2F6B57]/30'}`} data-id="element-302">
            {selected === 'elite' ? 'SÍ, QUIERO LA VERSIÓN ÉLITE COMPLETA →' : 'QUIERO MI RESCATE ACADÉMICO BASE →'}
          </motion.button>

          <p className="text-center text-slate-400 italic text-sm mt-4" data-id="element-303">
            {selected === 'elite' ? 'La opción más elegida por estudiantes de Kinesiología argentinos' : 'Toda la carrera organizada en un solo lugar'}
          </p>
        </motion.div>

        {/* Trust badges grid */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="grid grid-cols-2 gap-x-6 gap-y-4 max-w-md mx-auto mt-10 text-slate-600 text-sm md:text-base" data-id="element-304">
          <span className="flex items-center gap-2" data-id="element-305">
            <Lock className="w-5 h-5 text-slate-500" data-id="element-306" /> Pago seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-307">
            <Zap className="w-5 h-5 text-[#CDA24A]" data-id="element-308" /> Acceso en 5 min
          </span>
          <span className="flex items-center gap-2" data-id="element-309">
            <ShieldCheck className="w-5 h-5 text-[#2F6B57]" data-id="element-310" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2" data-id="element-311">
            <CreditCard className="w-5 h-5 text-slate-500" data-id="element-312" /> Tarjeta ·
            Transferencia
          </span>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center text-slate-500 font-semibold mt-8" data-id="element-313">
          +500 estudiantes ya tienen toda la carrera organizada
        </motion.p>
      </div>
    </section>;
}